// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".side-panel-district .side.primary .main-title[data-v-f6a63714] {\n  justify-content: space-between !important;\n}\n.side-panel-district .side.primary .list-items[data-v-f6a63714] {\n  height: calc(100% - 64px);\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
